<template>
  <div class="component-slider">
    <div
      id="track"
      class="component-slider__track"
    >
      <transition
        mode="out-in"
        :name="`${transitionPrefix}slide`"
      >
        <template v-for="(item, index) in items">
          <div
            v-if="isSlideActive(index)"
            class="component-slider__slide"
            :key="index"
          >
            <slot
              :item="item"
              :index="index"
            />
          </div>
        </template>
      </transition>
      <div class="component-slider__buttons">
        <b-button
          v-show="showPreviousButton"
          class="component-slider__prev-button"
          variant="link"
          @click="goToPreviousSlide"
        >
          <i
            class="fas fa-chevron-left"
            aria-hidden="true"
          />
        </b-button>
        <b-button
          v-show="showNextButton"
          class="component-slider__next-button"
          variant="link"
          @click="goToNextSlide"
        >
          <i
            class="fas fa-chevron-right"
            aria-hidden="true"
          />
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ComponentSlider',
  props: {
    items: {
      type: Array,
      default: () => ([]),
    },
  },
  data: () => ({
    active: 0,
    transitionPrefix: '',
  }),
  computed: {
    showPreviousButton() {
      return this.active !== 0;
    },
    showNextButton() {
      return this.active !== this.items.length - 1;
    },
  },
  methods: {
    setOverflowHiddenTemporarily() {
      const TRANSITION_MS = 600;
      const track = document.getElementById('track');
      track.style.overflowX = 'hidden';
      setTimeout(() => {
        track.style.overflowX = 'visible';
      }, TRANSITION_MS);
    },
    goToPreviousSlide() {
      this.setOverflowHiddenTemporarily();
      this.transitionPrefix = 'reverse-';
      this.active -= 1;
      this.$emit('previous', this.active);
    },
    goToNextSlide() {
      this.setOverflowHiddenTemporarily();
      this.transitionPrefix = '';
      this.active += 1;
      this.$emit('next', this.active);
    },
    isSlideActive(index) {
      return this.active === index;
    },
  },
};
</script>

<style lang="sass" scoped>
@import "src/styles/defaults/variables"

.component-slider
  &__track
    white-space: nowrap
    position: relative
    width: 100%
    box-sizing: border-box
    display: flex
    flex-wrap: nowrap
    will-change: transform
  &__buttons
    display: flex
    justify-content: space-between
    align-items: center
    position: absolute
    right: 0
    left: 0
    height: 100%
    width: 100%
  &__prev-button, &__next-button
    position: absolute
    z-index: 2
    &:focus
      box-shadow: none
    i
      font-size: 50px
      color: $color-secondary
      filter: drop-shadow(0px 2px 2px darkgray)
  &__prev-button
    left: 0
  &__next-button
    right: 0
  &__slide
    display: flex
    z-index: 1
    padding: 0 60px
    height: 100%
    min-height: 100px
    flex: 1 0
    white-space: normal
    align-items: center
    justify-content: center
    transition: 0.3s
  .reverse-slide-enter,
  .slide-leave-to
    transform: translate(-99.9%, 0)
  .reverse-slide-leave-to,
  .slide-enter
    transform: translate(99.9%, 0)
</style>
